(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.withdrawal-bank-account-rotw', ['pp.widgets-templates', 'pp.services.investor', 'pp.components.tooltip', 'pp.components.required-any', 'pp.values.form-lists']);

/**
 * @ngdoc directive
 * @name ppWithdrawalBankAccountrotw
 * @description
 * Allows the user to register a bank account.
 *
 *
 * @restrict A
 */
ngModule.directive('ppWithdrawalBankAccountRotw', [function () {
    return {
        restrict: 'A',
        templateUrl: 'widgets/_angular/withdrawal-bank-account-rotw/withdrawal-bank-account-rotw.tpl.html',
        scope: {
            account: '=ppWithdrawalBankAccountRotw'
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: ['formLists', 'investorService', function (formLists, investorService) {
            var vm = this;

            //-- initial state

            vm.formLists = formLists;

            vm.bicRegexp = investorService.bicRegexp;
            vm.ibanRegexp = investorService.ibanRegexp;

        }]
    };
}]);
})(window, window.angular);